import React, {useState, useEffect } from 'react'

import { Text, View, StyleSheet } from '@react-pdf/renderer';

export default function RecapDay(props) {

    const styles = StyleSheet.create({
        text: {
            fontSize: 11,
            marginTop: "5px"
        },
        title: {
            fontSize: 20,
        },
        menu: {
            fontSize: 14,
            fontWeight: "bold",
            marginBottom: "10px",
            marginTop: "10px"
        }
    })

    const [Day, setDay] = useState([]);
    const [Date, setDate] = useState('');

    // pain
    const [BouleCounter, setBouleCounter] = useState(0);
    const [BaguetteCounter, setBaguetteCounter] = useState(0);
    const [PdmCounter, setPdmCounter] = useState(0);
    const [PdmcCounter, setPdmcCounter] = useState(0);

    useEffect(() => {
        const getContent = () => {
            props.firebase.getMenusDate(props.uid, props.week, props.Day).get()
            .then(querySnapshot => {
                querySnapshot.docs.forEach(doc => {
                    props.firebase.getMenusContent(props.uid, props.week, props.Day, doc.id).get()
                    .then( doc => {
                        const mydata = doc.data()
                        setDay(mydata)
                        setDate(doc.id)
                    })
                })
            })
        }
        getContent()
    }, [props.Day, props.firebase, props.uid, props.week]);

    useEffect(() => {
        const getListing = () => {
            var boule = 0
            var baguette = 0
            var nature = 0
            var complet = 0
    
            props.firebase.getCustomers(props.uid).get()
            .then(querySnapshot => {
                querySnapshot.docs.forEach(doc => {
                    if (doc.data().tourNum === props.tour) {
                        props.firebase.getMenuNbr(props.uid, props.week, doc.id, props.Day).get()
                        .then( doc => {
                            doc.docs.forEach(result => {
                                if (result.data().boule !== undefined) {
                                    boule += Number(result.data().boule)
                                } else { boule += 0 }
                                if (result.data().baguette !== undefined) {
                                    baguette += Number(result.data().baguette)
                                } else { baguette += 0 }
                                if (result.data().nature !== undefined) {
                                    nature += Number(result.data().nature)
                                } else { nature += 0 }
                                if (result.data().complet !== undefined) {
                                    complet += Number(result.data().complet)
                                } else { complet += 0 }
    
                                setBouleCounter(boule)
                                setBaguetteCounter(baguette)
                                setPdmCounter(nature)
                                setPdmcCounter(complet)
        
                            })
                        })
                    }
                }) 
            })
        }
        if (props.firebase) {
            getListing()
        }
    }, [Day, props.Day, props.firebase, props.tour, props.uid, props.week]);

    return (
                <View style={{display: "flex", flexDirection: "column", alignItems: "center", marginTop: "20px"}}>
                    <Text>tournée {props.tour}</Text>
                    <div style={{display: "flex", flexDirection: "row"}}>
                        <Text style={{marginRight: "10px"}}>{props.jour}</Text>
                        <Text>{Date}</Text>
                    </div>
                    <Text style={styles.menu}>Boules : {BouleCounter}</Text>
                    <Text style={styles.menu}>Baguettes : {BaguetteCounter}</Text>
                    <Text style={styles.menu}>Pain de mie nature : {PdmCounter}</Text>
                    <Text style={styles.menu}>Pain de mie complet : {PdmcCounter}</Text>
                </View>
    )
}